import { iaRa } from 'lib/helpers/utility';

export const formatMedicationData = ({ medicationData, patientId }) => {
  return iaRa(medicationData).map((medication) => ({
    ...medication,
    createdBy: {
      ...medication?.createdBy,
      isPatient: Number(medication?.createdBy?.id) === Number(patientId)
    }
  }));
};
